import React, { Component } from "react";
import { List } from "immutable"; 
import { CaseService } from "services";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, message } from "antd";
import { Card, Descriptions, Menu, Table, Dropdown, Modal, Tooltip, Select, Button, Input, Spin } from "antd";
import { formatCurrency } from "utilities";
import moment from "moment";
import { previousCasesOverdue, fiMovementAction, 
    accountSummaryList
} from "services/case-service";
import "../../styles/document-review.css";
import CompanyService from "../../services/company-service";
import { history } from "router";

const ListItem = Descriptions.Item;
const CASE_STATUS_OPTIONS = ['Active', 'Closed', 'Open','Rejected','Hold',];

let prev_Data_keyLabel= {
    caseId: {
        title: "Previous Case ID",
    },
    sanctioned_limit: {
        title: "Sanctioned Limit",
    },
    sanction_date: {
        title: "Sanction Date",
    },
    seller_name:{
        title: "Seller Name"
    },
    anchor_name:{
        title: "Anchor Name"
    },
    adhoc_limit:{
        title: "Adhoc Limit"
    },
    loaded_limit:{
        title: "Loaded Limit"
    },
    total_repayment:{
        title: "Total Repayment"
    },
    average_utilization:{
        title: "Average Utilization"
    },
    ageing_first_disbursal:{
        title: "Ageing First Disbursal"
    },
    max_dpd:{
        title: "Max DPD"
    },
    dpd_last_6_months:{
        title: "DPD in last 6 months"
    },
    max_ageing:{
        title: "Max Ageing"
    },
    perc_invoices_od:{
        title: "% Invoices gone in OD"
    },
    nbr_of_invoices:{
        title:"Invoices Funded in last 12 months"
    },
    dpd_dd_value_0_30:{
        title:"Overdue < 30 days"
    },
    dpd_dd_value_31_60:{
        title:"Overdue 30 – 60 days"
    },
    dpd_dd_value_61_90:{
        title:"Overdue 60 – 90 days "
    },
    dpd_dd_value_91_9999:{
        title:"Overdue > 90 days"
    },
    max_ageing_in_last_12_months:{
        title:"Max Ageing in last 12 months"
    },
    // max_dpd_invoice_dd:{
    //     title:"Value of Invoice in Max Ageing"
    // },
    throughput:{
        title:"Throughput in last 12 months"
    },
};

function numberWithCommas(x) {
    return x.toString().split(".")[0].length > 3 ? x.toString().substring(0,x.toString().split(".")[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split(".")[0].length-3): x.toString();
}

const buyerExposureTableColumns = [
    {
        title:"Product Type",
        dataIndex: "business_product_type",
    },
    {
        title:"Proposed Limit",
        dataIndex: "proposed_limit",
        render: _ => formatCurrency(_)
    },
    {
        title:"Sanctioned Limit",
        dataIndex: "sanction_limit",
        render: _ => formatCurrency(_)
    },
    {
        title:"Base Active Limit",
        dataIndex: "base_active_limit",
        render: _ => formatCurrency(_)
    },
    {
        title:"Adhoc Limit",
        dataIndex: "adhoc_limit",
        render: _ => formatCurrency(_)
    },
    {
        title:"Current OS",
        dataIndex: "total_receivable",
        render: _=> formatCurrency(_)
    },
];
const AllCasesDataTitle = [
    {
        title:"Case ID",
        dataIndex: "id"
    },
    {
        title:"FI Partner",
        dataIndex: "bank.name"
    },
    {
        title:"Proposed / Sanctioned Limit",
        dataIndex: "proposed_or_sanction_limit"
    },
    {
        title:"Case Type",
        dataIndex: "case_type_display"
    },
    {
        title:"Case Status",
        dataIndex: "case_status_display"
    },
    {
        title:"Parent Case ID",
        dataIndex: "parent_case_detail"
    },
    {
        title:"Current Stage",
        dataIndex: "current_stage_display"
    },
    {
        title:"FI Movement",
        dataIndex: "fi_movement_display"
    },
    {
        title:"Is Rotation Case",
        dataIndex: "is_rotation_case",
        render: _ => _ ? "Yes" : "No",
    },
    {
        title:"Is Balance Transfer Case",
        dataIndex: "is_balance_transfer_case",
        render: _ => _ ? "Yes" : "No",
    },
];

const columnsBuyerOneView = [
    {
        title: "Seller(s)",
        dataIndex: "seller",
        align: "center",
        width: 10,
    },
    {
        title: "Anchor(s)",
        dataIndex: "anchor",
        align: "center" ,
        width: 10,
    },
    {
        title: "Current limit",
        dataIndex: "current_limit",
        align: "center" ,
        width: 10,
    },
    {
        title: "Proposed limit",
        dataIndex: "proposed_limit",
        align: "center" ,
        width: 10,
    },
    {
        title: "Extra docs required",
        dataIndex: "extra_docs_required",
        align: "center" ,
        width: 50,
    },
];

const columnsBuyerLimitExposure = [
    { title: "Case ID", dataIndex: "case_id", key: "case_id", align: "center"},
    { title: "Case Status", dataIndex: "case_status", key: "case_status", align: "center"},
    { title: "Case Stage", dataIndex: "case_stage", key: "case_stage", align: "center", width: "40%" },
    { title: "Case Type", dataIndex: "case_type", key: "case_type", align: "center"},
    { title: "FI Movement", dataIndex: "fi_movement", key: "fi_movement", align: "center"},
];

class PreviousCases extends Component {

state = {
    casesList: null,
    selectedItems: [],
    totalResDataValues: [],
    filteredResDataValues: [],
    fetchedCasesList: false,
    previousCaseList:[],
    caseUserId:null,
    previousCases : {[" "]:{
        caseId: {
            ...prev_Data_keyLabel.caseId,
        },
        sanctioned_limit: {
            ...prev_Data_keyLabel.sanctioned_limit,
        },
        sanction_date: {
            ...prev_Data_keyLabel.sanction_date,
        },
        seller_name:{
            ...prev_Data_keyLabel.seller_name,
        },
        anchor_name:{
            ...prev_Data_keyLabel.anchor_name,
        },
        adhoc_limit:{
            ...prev_Data_keyLabel.adhoc_limit,
        },
        loaded_limit:{
            ...prev_Data_keyLabel.loaded_limit,
        },
        total_repayment:{
            ...prev_Data_keyLabel.total_repayment,
        },
        average_utilization:{
            ...prev_Data_keyLabel.average_utilization,
        },
        ageing_first_disbursal:{
            ...prev_Data_keyLabel.ageing_first_disbursal,
        },
        max_dpd:{
            ...prev_Data_keyLabel.max_dpd,
        },
        dpd_last_6_months:{
            ...prev_Data_keyLabel.dpd_last_6_months,
        },
        max_ageing_in_last_12_months:{
            ...prev_Data_keyLabel.max_ageing_in_last_12_months,
        },
        perc_invoices_od:{
            ...prev_Data_keyLabel.perc_invoices_od,
        },
        nbr_of_invoices:{
            ...prev_Data_keyLabel["nbr_of_invoices"],
        },
        dpd_dd_value_0_30:{
            ...prev_Data_keyLabel["dpd_dd_value_0_30"],
        },
        dpd_dd_value_31_60:{...prev_Data_keyLabel["dpd_dd_value_31_60"],
        },
        dpd_dd_value_61_90:{...prev_Data_keyLabel["dpd_dd_value_61_90"],
        },
        dpd_dd_value_91_9999:{...prev_Data_keyLabel["dpd_dd_value_91_9999"],
        },
        max_ageing:{...prev_Data_keyLabel["max_ageing"],
        },
        throughput:{...prev_Data_keyLabel["throughput"],
        },
    }},
    allCasesData: [],
    totalResDataValues: [],
    showModalCaseTypes:{
        showTagExistingCaseModal: false,
        showCreateNewCaseModal: false,
        showUntagCaseModal: false,
        showBalanceTransferCaseModal: false,
    },
    selectedRowsAllCases: [],
    partnerbank_data: [],
    proposed_limit: null,
    existing_case: null,
    loading: false,
    tableLoading: true,
    buyerData: [],
    buyerLimitExposure: [],
    buyerLimitExposureFacility: [],
    dbViewTableData: [],
    dbViewTableColumns: [],
    loadingBuyerLimitExposure: false,
    loadingCreditBuyerView: false,
    buyerExposureData: [],
    buyerExposureLoader: true
}

componentDidMount() {
    this.handleFetchPreviousCasesList();
    this.setState({fetchedCasesList:true});
    this.creditEnBuyerViewFn();
    this.buyerLimitExpFn();
    this.buyerExposureViewFn();
}

componentDidUpdate(prevProps) {
    if(!this.state.fetchedCasesList && this.props.caseId) {
        this.handleFetchPreviousCasesList();
    }
}


buyerExposureViewFn=()=>{
    CompanyService.getCaseBuyerExposure(this.props.caseId).then((res) => {
        this.setState({ buyerExposureData: res?.data?.data, buyerExposureLoader: false });
    })
        .catch((error) => {
            console.error("Error fetching buyer exposure:", error);
            this.setState({buyerExposureLoader:false})
        });
}

creditEnBuyerViewFn = () => {
    this.setState({loadingCreditBuyerView: true});
    CompanyService.getCreditEnhancementBuyerView(this.props.caseId).then(({data}) => {
        const buyerViewData = data.map(el=>({
            "seller": el.seller,
            "anchor": el.anchor,
            "current_limit": typeof el.current_limit === "number" && el.current_limit>0 ? "₹" + formatCurrency(el.current_limit, false) : el.current_limit,
            "proposed_limit": typeof el.proposed_limit === "number" && el.proposed_limit>0 ? "₹" + formatCurrency(el.proposed_limit, false) : el.proposed_limit,
            "extra_docs_required": el.extra_docs_required?.join(", ")
        }));
        this.setState({buyerData:
            [...buyerViewData],
        loadingCreditBuyerView: false
        });
    }).catch((err) => {
        message.error(err?.non_field_error && err?.non_field_error.length && err?.non_field_error[0] || "Something went wrong");
        this.setState({loadingCreditBuyerView: false});
    });
}

buyerLimitExpFn = () => {
    this.setState({loadingBuyerLimitExposure: true});
    CompanyService.getCreditEnhancementBuyerLimitExposure(this.props.caseId).then(({data}) => {
        const dataCaseLevel = [];
        let dataFacilityLevel = [];
        let bulkFacilityData = {};
        data.map(el=> {
            dataFacilityLevel = [];
            const bulkDataFacility = el.case;
            dataCaseLevel.push({
                case_id: el.id || null,
                case_status: el.status || null,
                case_stage: el.case_stage?.join(", ") || null,
                case_type: el.case_type || null,
                fi_movement: el.fi_movement || null,
            });
            bulkDataFacility.map(ele=>{
                dataFacilityLevel.push({
                    id: ele.id || null,
                    lending_partner_name: ele.lending_partner_name || null,
                    seller_name: ele.seller_name || null,
                    approved_limit: ele.approved_limit && "₹" + formatCurrency(ele.approved_limit, false),
                    loaded_limit: ele.loaded_limit && "₹" + formatCurrency(ele.loaded_limit, false),
                    utilized_limit: ele.utilized_limit && "₹" + formatCurrency(ele.utilized_limit, false),
                    available_limit: ele.available_limit && "₹" + formatCurrency(ele.available_limit, false),
                    overdue_amount: ele.overdue_amount && "₹" + formatCurrency(ele.overdue_amount, false),
                    stop_billing: ele.stop_billing?.toString()?.toUpperCase() || null,
                });
            });
            bulkFacilityData[el.id]= dataFacilityLevel;
        });
        this.setState({buyerLimitExposure: dataCaseLevel, buyerLimitExposureFacility: bulkFacilityData, loadingBuyerLimitExposure: false
        });
    }).catch((err) => {
        message.error(err?.non_field_error && err?.non_field_error.length && err?.non_field_error[0] || "Something went wrong");
        this.setState({loadingBuyerLimitExposure: false});
    });
}

handleChange = (selectedItems) => {
        this.setState({ selectedItems });
     if (selectedItems && selectedItems.length > 0) {
        const filteredCases = this.state.totalResDataValues.filter(
            caseItem => selectedItems.includes(caseItem.case_status_display)
        );
        this.setState({ filteredResDataValues: filteredCases });
    } else {
        this.setState({ filteredResDataValues: this.state.totalResDataValues });
    }
    };
handleFetchPreviousCasesList = () => {
    const caseId = this.props.caseId;
    if(!this.state.fetchedCasesList && caseId) {
        CaseService.newCaseSearchList(caseId).then(({ data }) => {
            const allCaseIds = data.map(el=>el.id);
            let modifiedData = data.map(el=>{return(
                {...el, proposed_or_sanction_limit: formatCurrency(el["proposed_or_sanction_limit"])});});
            this.setState({
                totalResDataValues: modifiedData, tableLoading: false, fetchedCasesList: true});
            let previousCasesObj = {};
            accountSummaryList([allCaseIds]).then(res=>{
                if(res.status === 200){
                    const allCasesDataResult = res.data.results;
                    this.setState({allCasesData:res.data.results});
                    allCasesDataResult.map(el=>{
                        previousCasesObj[el["case"]] ={ 
                            caseId: {
                                ...prev_Data_keyLabel.caseId,
                                value: `PGCP-${el["case"]}`
                            },
                            sanctioned_limit: {
                                ...prev_Data_keyLabel.sanctioned_limit,
                                value: formatCurrency(el["sanction_limit"], false) || "--"
                            },
                            sanction_date: {
                                ...prev_Data_keyLabel.sanction_date,
                                value:el["sanction_date"] ? moment(el["sanction_date"]).format("DD/MM/YYYY") : (el["sanction_date"] ?? "--")
                            },
                            seller_name:{
                                ...prev_Data_keyLabel.seller_name,
                                value: el["sellers"] || "--",
                            },
                            anchor_name:{
                                ...prev_Data_keyLabel.anchor_name,
                                value: el["anchors"] || "--"
                            },
                            adhoc_limit:{
                                ...prev_Data_keyLabel.adhoc_limit,
                                value: formatCurrency(el["adhoc_limit"], false) || "--"
                            },
                            loaded_limit:{
                                ...prev_Data_keyLabel.loaded_limit,
                                value: formatCurrency(el["loaded_limit"], false) || "--"
                            },
                            total_repayment:{
                                ...prev_Data_keyLabel.total_repayment,
                                value: formatCurrency(el["repayment_amount"], false) || "--"
                            },
                            average_utilization:{
                                ...prev_Data_keyLabel.average_utilization,
                                value: formatCurrency(el["avg_utilization"], false) || "--"
                            },
                            ageing_first_disbursal:{
                                ...prev_Data_keyLabel.ageing_first_disbursal,
                                value: el["first_disbursal_ageing"] || "--"
                            },
                            max_dpd:{
                                ...prev_Data_keyLabel.max_dpd,
                                value: el["max_dpd"] || "--"
                            },
                            dpd_last_6_months:{
                                ...prev_Data_keyLabel.dpd_last_6_months,
                                value: el["dpd_last_6_months"] || "--"
                            },
                            max_ageing_in_last_12_months:{
                                ...prev_Data_keyLabel.max_ageing_in_last_12_months,
                                value: el["max_ageing_in_last_12_months"] || "--"
                            },
                            perc_invoices_od:{
                                ...prev_Data_keyLabel.perc_invoices_od,
                                value: el["perc_invoices_gone_in_od"] || "--"
                            },
                            nbr_of_invoices:{
                                ...prev_Data_keyLabel["nbr_of_invoices"],
                                value: el["invoices_funded_in_last_12_months"] || "--"
                            },
                            dpd_dd_value_0_30:{
                                ...prev_Data_keyLabel["dpd_dd_value_0_30"],
                                value: el["overdue_less_than_30_days"] || "--"
                            },
                            dpd_dd_value_31_60:{...prev_Data_keyLabel["dpd_dd_value_31_60"],
                                value: el["overdue_between_30_to_60_days"] || "--"
                            },
                            dpd_dd_value_61_90:{...prev_Data_keyLabel["dpd_dd_value_61_90"],
                                value: el["overdue_between_60_to_90_days"] || "--"
                            },
                            dpd_dd_value_91_9999:{...prev_Data_keyLabel["dpd_dd_value_91_9999"],
                                value: el["overdue_greater_than_90_days"] || "--"
                            },
                            max_ageing:{...prev_Data_keyLabel["max_ageing"],
                                value: el["max_ageing"] || "--"
                            },
                            throughput:{...prev_Data_keyLabel["throughput"],
                                value: formatCurrency(el["throughput_last_12_month"], false) || "--"
                            },
                        };
                    });
                    previousCasesObj && this.props.overdueData(previousCasesObj);
                    this.setState(({
                        casesList: new List(data.filter(_ => _.id !== this.props.caseId)),
                        previousCaseList: data.filter(_ => _.id !== this.props.caseId),
                        caseUserId:res["id"],
                        fetchedCasesList: true,
                        previousCases:{...previousCasesObj},
                    }));
                }
            }).catch((err) => {
                console.log(err);
            });
           
            // res.map(el=>this.fetchPreviousCasesOverdue(el["id"]));
        }).catch(() => {
            this.setState({
                fetchedCasesList: true
            });
        });
    } else if(!this.state.fetchedCasesList) {
        this.setState({
            casesList: new List([]),
            fetchedCasesList: true,
            callPrevCase: false
        });
    }   
}
    rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({
                selectedRowsAllCases: selectedRows.filter(
                    r => ['Active', 'Open'].includes(r.case_status_display)
                )
            });
        },
        getCheckboxProps: (record) => {
         const rowIndex = 0;
         return {
            disabled:( !(!this.props.recreditViewOnlyPermission && (this.props.permissionContext && this.props.permissionContext.toJS().page_all_cases_fi_movement_action) && rowIndex === 0) || !['Active', 'Open'].includes(record.case_status_display)) 
         };
     }};
fetchPreviousCasesOverdue = (caseId) => {
    const previousCases = this.state.previousCases || {};
    previousCasesOverdue(caseId).then(res=>{
        const res_data = res.data; 
        prev_Data_keyLabel = {
            seller_name:{
                ...prev_Data_keyLabel.seller_name,
                value: res_data["seller_name"]
            },
            anchor_name:{
                ...prev_Data_keyLabel.anchor_name,
                value: res_data["anchor_name"]
            },
            adhoc_limit:{
                ...prev_Data_keyLabel.adhoc_limit,
                value: res_data["adhoc_limit"]
            },
            loaded_limit:{
                ...prev_Data_keyLabel.loaded_limit,
                value: res_data["loaded_limit"]
            },
            total_repayment:{
                ...prev_Data_keyLabel.total_repayment,
                value: res_data["total_repayment"]
            },
            average_utilization:{
                ...prev_Data_keyLabel.average_utilization,
                value: res_data["average_utilization"]
            },
            ageing_first_disbursal:{
                ...prev_Data_keyLabel.ageing_first_disbursal,
                value: res_data["ageing_first_disbursal"]
            },
            max_dpd:{
                ...prev_Data_keyLabel.max_dpd,
                value: res_data["max_dpd"]
            },
            dpd_last_6_months:{
                ...prev_Data_keyLabel.dpd_last_6_months,
                value: res_data["dpd_last_6_months"]
            },
            max_ageing_in_last_12_months:{
                ...prev_Data_keyLabel.max_ageing_in_last_12_months,
                value: res_data["max_ageing_in_last_12_months"]
            },
            perc_invoices_od:{
                ...prev_Data_keyLabel.perc_invoices_od,
                value: res_data["perc_invoices_od"]
            },
            nbr_of_invoices:{
                ...prev_Data_keyLabel["nbr_of_invoices"],
                value: res_data["nbr_of_invoices"]
            },
            dpd_dd_value_0_30:{
                ...prev_Data_keyLabel["dpd_dd_value_0_30"],
                value:res_data["dpd_dd_value_0_30"]
            },
            dpd_dd_value_31_60:{...prev_Data_keyLabel["dpd_dd_value_31_60"],
                value: res_data["dpd_dd_value_31_60"]
            },
            dpd_dd_value_61_90:{...prev_Data_keyLabel["dpd_dd_value_61_90"],
                value: res_data["dpd_dd_value_61_90"]
            },
            dpd_dd_value_91_9999:{...prev_Data_keyLabel["dpd_dd_value_91_9999"],
                value: res_data["dpd_dd_value_91_9999"]
            },
            max_ageing:{...prev_Data_keyLabel["max_ageing"],
                value: res_data["max_ageing"]
            },
            throughput:{...prev_Data_keyLabel["throughput"],
                value:res_data["throughput"] && numberWithCommas(res_data["throughput"])
            },
        };
        previousCases[caseId] = { ...previousCases[caseId],...prev_Data_keyLabel};
        this.state.previousCases && this.props.overdueData(this.state.previousCases);
        return(this.setState({
            previousCases:{...previousCases},
        }));
    });}

    showModalCaseTypesFn = (typeCase) => {
        this.setState({
            showModalCaseTypes:{
                ...this.state.showModalCaseTypes,
                [typeCase] : !this.state.showModalCaseTypes[typeCase]}
        });
        this.setState({proposed_limit: this.state.selectedRowsAllCases.map(el=>parseInt(el.proposed_or_sanction_limit.replace(/,/g, ""))).reduce((partialSum, a) => parseInt(partialSum) + a, 0)});
        CompanyService.getLendingPartners().then(({ data }) => {
            this.setState({
                partnerbank_data: data
            });
        }).catch(() => {
            console.log("error");
        });
    }

        getMenu = () => {
            let menu=[];
            menu.push({
                key: "tagExistingCase",
                type: "default",
                onClick: () => this.showModalCaseTypesFn("showTagExistingCaseModal"),
                // disabled: this.state.disableActionButton,
                label: "Tag Existing Case "
            },
            {
                key: "createNewCase",
                type: "default",
                onClick: () => this.showModalCaseTypesFn("showCreateNewCaseModal"),
                label: "Create New Case"
            },
            {
                key: "balanceTransferCase",
                type: "default",
                onClick: () => this.showModalCaseTypesFn("showBalanceTransferCaseModal"),
                label: "Balance Transfer Case"
            },
            );

            return <Menu>
                {menu.map(_ => {
                    return (
                        <Menu.Item
                            key={_.key}
                            size={"small"}
                            className={_.className}
                            onClick={_.onClick}
                            htmlType={_.htmlType || "button"}
                            disabled={_.disabled}>
                            {_.label}
                        </Menu.Item>
                    );
                }
                )}
            </Menu>;
        };
        parentFiMovement = (array, type) => {
            let typeBtnFilter;
            type === "create_case" ? typeBtnFilter = "can_be_parent_of_fi_movement" : typeBtnFilter = "can_be_untagged_as_fi_movement";
            return array.length>0 && array.every(el=>el[typeBtnFilter]);
        }

        filteredArray = (array1 ,array2) => array1.filter(function(array_el){
            return array2.filter(function(anotherOne_el){
                return anotherOne_el.id == array_el.id;
            }).length == 0;
        });
        filteredArrayPartnerBank = (array1 ,array2) => array1.filter(function(array_el){
            return array2.filter(function(anotherOne_el){
                return anotherOne_el.bank.id == array_el.id;
            }).length == 0;
        });

        submitForm = (typeOfAction, closeModalVar) => {
            let body;
            typeOfAction === "tag" ? 
                this.state.existing_case ? 
                    body = { 
                        "fi_movement_parent_case_ids": this.state.selectedRowsAllCases?.map(el=>el.id), 
                        "case_id": this.state.existing_case, 
                        "action_type": "tag" 
                    } :message.error("No existing case selected") : 
                typeOfAction === "untag" ? 
                    body = { 
                        "case_id": this.state.selectedRowsAllCases?.map(el=>el.id)[0], 
                        "action_type": "untag" 
                    } : typeOfAction === "create" ?
                        this.state.proposed_limit > 0 ? body = { 
                            "fi_movement_parent_case_ids": this.state.selectedRowsAllCases.map(el=>el.id), 
                            "proposed_limit": this.state.proposed_limit || this.state.selectedRowsAllCases.map(el=>el.proposed_or_sanction_limit).reduce((partialSum, a) => parseInt(partialSum) + a, 0), 
                            "partner_bank_id": this.state.partner_bank_id, 
                            "action_type": "create" 
                        } : message.error("Please enter Proposed limit > 0") : typeOfAction === "balanceTransfer" ?
                            this.state.proposed_limit > 0 ? body = { 
                                "fi_movement_parent_case_ids": this.state.selectedRowsAllCases.map(el=>el.id), 
                                "proposed_limit": this.state.proposed_limit || this.state.selectedRowsAllCases.map(el=>el.proposed_or_sanction_limit).reduce((partialSum, a) => parseInt(partialSum) + a, 0), 
                                "partner_bank_id": this.state.partner_bank_id, 
                                "is_balance_transfer_case": true, 
                                "action_type": "balance_transfer" 
                            } : message.error("Please enter Proposed limit > 0") 
                        : null;
            try {
                this.setState({
                    showModalCaseTypes:{
                        ...this.state.showModalCaseTypes,
                        [closeModalVar] : !this.state.showModalCaseTypes[closeModalVar]},
                    loading: true
                });
                body && fiMovementAction(body).then(res=>{ 
                    if(res.status === 200){
                        message.success(res.data.message); 
                        this.setState({
                            selectedRowsAllCases:[],
                            fetchedCasesList: false,
                            existing_case: null,
                            loading: false
                        });
                        this.handleFetchPreviousCasesList;
                    }}).catch((err) => {
                    console.log("error", err);
                    this.setState({
                        showModalCaseTypes:{
                            ...this.state.showModalCaseTypes,
                            [closeModalVar] : !this.state.showModalCaseTypes[closeModalVar]},
                        loading: false
                    });
                    if (err &&err.non_field_errors) {
                        message.error(Object.values(err)[0]);
                        this.setState({
                            loading: false
                        });
                    } else {
                        message.error("Something went wrong!");
                        this.setState({
                            loading: false
                        });
                    }
                });
            }catch (e) {
                message.error("Something went wrong");
            }
        }
        onSelectUser = (val, variable) => {
            variable === "existingCase" ? this.setState({existing_case:val}) : this.setState({partner_bank_id:val});
        }
        redirectToCaseId = (e, value) =>{
            history.replace({pathname:`/app/inbox/${value}/credit_summary`});
        }
        expandedRowRender = (row) => {
            const columns = [
                { title: "Facility ID", dataIndex: "id", key: "id", align: "center"  },
                { title: "Seller Name", dataIndex: "seller_name", key: "seller_name", align: "center"  },
                { title: "FI Partner Name", dataIndex: "lending_partner_name", key: "lending_partner_name", align: "center"  },
                { title: "Approved/Sanctioned Limit", dataIndex: "approved_limit", key: "approved_limit", align: "center"  },
                { title: "Loaded Limit", dataIndex: "loaded_limit", key: "loaded_limit", align: "center"  },
                { title: "Utilized Limit", dataIndex: "utilized_limit", key: "utilized_limit", align: "center"  },
                { title: "Available Limit", dataIndex: "available_limit", key: "available_limit", align: "center"  },
                { title: "Overdue Amount", dataIndex: "overdue_amount", key: "overdue_amount", align: "center"  },
                { title: "Stop Billing", dataIndex: "stop_billing", key: "stop_billing", align: "center" },
            ];
            let facilityData = this.state.buyerLimitExposureFacility[row.case_id];
            return <Table columns={columns} dataSource={facilityData} pagination={false} />;
        };

        render() {
             const { selectedItems } = this.state;
            return (
                <>
                <Spin spinning={this.state.loading}>
                    <div className="d-flex flex-column">
                        <div className="ant-col p-10 d-flex" style={{justifyContent:"end"}}>
                            <Modal
                                visible={this.state.showModalCaseTypes.showTagExistingCaseModal}
                                onOk={() => this.submitForm("tag", "showTagExistingCaseModal")}
                                onCancel={() => this.showModalCaseTypesFn("showTagExistingCaseModal")}
                                okText={"Submit"}
                                title={"Select Existing Case"}>
                                <div className="w-100">
                                    <p className="dropdown-class">Select Existing Case</p>
                                    <Select
                                        className="w-100"
                                        placeholder={"Select Existing Case"}
                                        onSelect={(val) => this.onSelectUser(val, "existingCase")}
                        
                                    >
                                        {this.state.totalResDataValues.length>0 && this.state.selectedRowsAllCases.length>0 && this.filteredArray(this.state.totalResDataValues, this.state.selectedRowsAllCases).filter(el=>el.can_be_tagged_as_fi_movement).map(_ => (
                                            <Select.Option key={_.id} value={_.id}>
                                                {`${_.id} | ${_.bank?.code} | ${_.current_stage_display}`}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </Modal>
                            <Modal
                                visible={this.state.showModalCaseTypes.showCreateNewCaseModal}
                                onOk={() => this.submitForm("create", "showCreateNewCaseModal")}
                                onCancel={() => this.showModalCaseTypesFn("showCreateNewCaseModal")}
                                okText={"Submit"}
                                title={"Create New Case"}>
                                <div className="d-flex justify-content-space-between">
                                    <div className="w-100">
                                        <p className="dropdown-class">Select Partner Bank</p>
                                        <Select
                                            className="w-80"
                                            placeholder={"Select Partner Bank"}
                                            onSelect={(val) => this.onSelectUser(val, "partnerBank")}
                                        >
                                            {this.filteredArrayPartnerBank(this.state.partnerbank_data, this.state.selectedRowsAllCases).map(_ => (
                                                <Select.Option key={_.id} value={_.id}>
                                                    {_.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="w-100">
                                        <p className="dropdown-class">Proposed Limit</p>
                                        <Input
                                            type={"text"}
                                            onChange={val => {
                                                this.setState({
                                                    proposed_limit: val.target.value
                                                });
                                            }}
                                            placeholder="Enter proposed limit"
                                            value={this.state.proposed_limit}
                                            style={{width:"80%"}}
                                        />
                                    </div>
                                </div>
                            </Modal>
                            <Modal
                                visible={this.state.showModalCaseTypes.showBalanceTransferCaseModal}
                                onOk={() => this.submitForm("balanceTransfer", "showBalanceTransferCaseModal")}
                                onCancel={() => this.showModalCaseTypesFn("showBalanceTransferCaseModal")}
                                okText={"Submit"}
                                title={"Select Balance Transfer Case"}>
                                 <div className="d-flex justify-content-space-between">
                                    <div className="w-100">
                                        <p className="dropdown-class">Select Balance Transfer Case</p>
                                        <Select
                                            className="w-80"
                                            placeholder={"Select Balance Transfer Case"}
                                            onSelect={(val) => this.onSelectUser(val, "partnerBank")}
                                        >
                                            {this.filteredArrayPartnerBank(this.state.partnerbank_data, this.state.selectedRowsAllCases).map(_ => (
                                                <Select.Option key={_.id} value={_.id}>
                                                    {_.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="w-100">
                                        <p className="dropdown-class">Proposed Limit</p>
                                        <Input
                                            type={"text"}
                                            onChange={val => {
                                                this.setState({
                                                    proposed_limit: val.target.value
                                                });
                                            }}
                                            placeholder="Enter proposed limit"
                                            value={this.state.proposed_limit}
                                            style={{width:"80%"}}
                                        />
                                    </div>
                                </div>
                            </Modal>
                            <Modal
                                visible={this.state.showModalCaseTypes.showUntagCaseModal}
                                onOk={() => this.submitForm("untag", "showUntagCaseModal")}
                                onCancel={() => this.showModalCaseTypesFn("showUntagCaseModal")}
                                okText={"Proceed"}
                                title={"Un-Tag Case"}>
                            </Modal>
                            {
                                <div className="d-flex">
                                    <Tooltip className="d-flex justify-content-center" title={!(this.state.selectedRowsAllCases.length >=1 && this.parentFiMovement(this.state.selectedRowsAllCases, "create_case")) && "Select valid case(s)"}>
                                        <span>
                                            <Dropdown.Button type="primary" style={{ borderRadius: "8px", margin: "2rem" }} disabled={!(!this.props.recreditViewOnlyPermission && (this.state.selectedRowsAllCases.length >=1 && this.parentFiMovement(this.state.selectedRowsAllCases, "create_case")))} overlay={this.getMenu}>FI Movement: Tag / Create Case</Dropdown.Button>
                                        </span>
                                    </Tooltip>
                                    <Tooltip className="d-flex justify-content-center" title={!(this.state.selectedRowsAllCases.length >=1 && this.parentFiMovement(this.state.selectedRowsAllCases, "un-tag_case")) && "Select valid case(s)"}>
                                        <span>
                                            <Button type="primary" style={{borderRadius: "8px", margin: "2rem" }} disabled={!(!this.props.recreditViewOnlyPermission && (this.state.selectedRowsAllCases.length ===1 && this.parentFiMovement(this.state.selectedRowsAllCases, "un-tag_case")))} onClick={()=>  this.showModalCaseTypesFn("showUntagCaseModal")}>FI Movement: Un-tag Case</Button>
                                        </span>
                                    </Tooltip>
                                    <Select
                                    mode="multiple"
                                    placeholder="Select Case Status"
                                    value={selectedItems}
                                    onChange={this.handleChange}
                                    style={{ borderRadius: "8px", margin: "2rem", width: "400px", height: "45px", fontSize: "14px"}}
                                    getPopupContainer={trigger => trigger.parentNode}
                                >
                                    {CASE_STATUS_OPTIONS.map(item => (
                                        <Select.Option key={item} value={item}>
                                            {item}
                                        </Select.Option>
                                    ))}
                                    </Select>
                                </div>                            
                                }
                        </div>
                        {
                            <Table
                                bordered 
                                size={"middle"}
                                rowKey="id"
                                rowSelection={{
                                    type: "checkbox",
                                    ...this.rowSelection,
                                }}
                                columns={AllCasesDataTitle}
                                className={"p-10 ant-col padless-card"}
                                dataSource={this.state.selectedItems.length > 0 ? this.state.filteredResDataValues : this.state.totalResDataValues} 
                                loading={this.state.tableLoading}
                                noRowSelection={false}
                                pagination={{
                                    defaultPageSize: 50,
                                    pageSize: 50,
                                }}
                                onRow={(record) => ({ style: { backgroundColor: ["Rejected", "Closed", "Hold"].includes(record.case_status_display) ? "rgb(255 153 153)"
                                : "transparent",  
                                    },
                                })}
                            />}
                             {
                            <Table
                                bordered 
                                size={"middle"}
                                columns={buyerExposureTableColumns}
                                className={"p-10 ant-col padless-card"}
                                dataSource={this.state.buyerExposureData}
                                loading={this.state.buyerExposureLoader} 
                                noRowSelection={false}
                                pagination={{
                                    defaultPageSize: 50,
                                    pageSize: 50,
                                }}
                                onRow={(record) => ({ style: { backgroundColor: ["Rejected", "Closed", "Hold"].includes(record.case_status_display) ? "rgb(255 153 153)" :"transparent",  
                                    },
                                })}
       
                            />}
                        {Object.values(this.state.previousCases).map(el=>{
                            return(
                                <Col span={15} className={"p-10"}  key={el.title}>
                                    <Card className={"padless-card"}>
                                        <Descriptions bordered size={"middle"} column={2}>
                                            {Object.values(el).map(indexEl=>{
                                                return(
                                                    <ListItem
                                                        label={indexEl.title}
                                                        span={1}
                                                        key={indexEl.title}
                                                    >
                                                        {indexEl.title === "Previous Case ID" ? <a href="" role="button"
                                                            onClick={(e) => this.redirectToCaseId(e, indexEl.value && indexEl.value.split("-")[1])}
                                                        > {indexEl?.value}</a>  : indexEl.value === "0.00" ? "0" : indexEl.value || "--"}
                                                    </ListItem>
                                                );
                                            })
                                            };
                                        </Descriptions>
                                    </Card>
                                </Col>
                            );})}
                    </div>
                </Spin>
                <Col span={24} className={"p-10"}>
                    <Card
                        title={"Limit exposure view and additional documents required"}
                        className={"padless-card"}
                    >
                        <Table 
                            bordered 
                            columns={columnsBuyerOneView} 
                            className={"p-10 ant-col padless-card"}
                            dataSource={this.state.buyerData} 
                            size="small" 
                            pagination={false}
                            loading={this.state.loadingCreditBuyerView}
                        />
                    </Card>
                </Col>
                <Col span={24} className={"p-10"}>
                    <Card
                        title={"Detailed view - Buyer Limit exposure"}
                        className={"padless-card"}
                    >
                        {/* <Title level={2} className="d-flex justify-content-center">Detailed view - Buyer Limit exposure</Title> */}
                        <Table
                            bordered 
                            className="components-table-demo-nested p-10 ant-col padless-card"
                            columns={columnsBuyerLimitExposure}
                            expandedRowRender={this.expandedRowRender}
                            dataSource={this.state.buyerLimitExposure}
                            size="middle"
                            pagination={false}
                            loading={this.state.loadingBuyerLimitExposure}
                        />
                    </Card>
                </Col>
                </>
            );
        }
}

PreviousCases.propTypes = {
    company: PropTypes.object,
    isParentCaseExist: PropTypes.bool,
    caseId: PropTypes.number,
    data: PropTypes.object,
    user: PropTypes.object,
    permissionContext: PropTypes.object,
    overdueData: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => ({
    isParentCaseExist: !!state.caseDetails.getIn([props.caseId, "data", "parent_case_detail"]),
    user : state.user.get("data")
});

export default connect(mapStateToProps, null)(PreviousCases);
